import React, { Component } from "react";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { Button, FormControl, FormLabel, InputAdornment, Tab, Tabs, TextField } from "@material-ui/core";
import CustomDialog from "../layout/CustomDialog";
import { GetApp } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import dealsService from "../../services/dealsService";
import { numberWithCommas } from "../../services/utils/utils";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CustomBasicTable from "../layout/CustomBasicTable";
import filesService from "../../services/docsService/filesService";
import { confirmTaxAuthorityDocumentGenerationOncePerDeal } from "../shared/dialogs/taxAuthorityDocumentConfirm";
import { get49aJsonExportGroups } from "./dialog49aJsonExports";
import {
  INSTRUCTION_TITLES,
  create49aFullExemptionInstruction,
  create49aPartialExemptionInstruction,
  createRegularSaleInstruction
} from "./dialog49aInstructions";

const RTL_TEXT_STYLE = { direction: "rtl", textAlign: "right" };
const DIALOG_CONTENT_STYLE = {
  color: "#1e3d66",
  direction: "rtl",
  fontFamily: '"Rubik", "Helvetica", "Arial", sans-serif',
  padding: "0 28px"
};
const DIALOG_PAPER_STYLE = {
  borderRadius: 16,
  boxShadow: "0 18px 40px rgba(30, 61, 102, 0.22)",
  maxWidth: 600,
  overflow: "hidden"
};
const DIALOG_TITLE_STYLE = {
  background: "#1e3d66",
  padding: "12px 20px"
};
const DIALOG_TITLE_TYPOGRAPHY_STYLE = {
  fontSize: 20,
  fontWeight: 800,
  lineHeight: 1.25
};
const CANDIDATE_OPTION_STYLE = { ...RTL_TEXT_STYLE, lineHeight: 1.35, width: "100%" };
const RADIO_GROUP_STYLE = {
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  justifyContent: "flex-start",
  marginTop: 10
};
const RADIO_OPTION_STYLE = {
  background: "#e8eef4",
  border: 0,
  borderRadius: 18,
  boxShadow: "none",
  color: "#1e3d66",
  cursor: "pointer",
  fontFamily: "inherit",
  fontSize: 15,
  fontWeight: 700,
  minWidth: 88,
  padding: "8px 18px"
};
const SELECTED_RADIO_OPTION_STYLE = {
  background: "linear-gradient(180deg, #ffb109 0%, #ff9800 100%)",
  boxShadow: "0 3px 8px rgba(255, 152, 0, 0.3)",
  color: "#1e3d66"
};
const ELIGIBILITY_SEPARATOR_STYLE = {
  border: 0,
  borderTop: "1px solid #d5e0ea",
  margin: "18px 0 0",
  width: "100%"
};
const ELIGIBILITY_GRID_STYLE = {
  direction: "rtl",
  marginBottom: 8,
  textAlign: "right",
  width: "100%"
};
const ELIGIBILITY_QUESTION_STYLE = {
  alignItems: "flex-start",
  paddingTop: 18,
  width: "100%"
};
const FORM_LABEL_STYLE = {
  color: "#1e3d66",
  fontSize: 16,
  fontWeight: 700,
  lineHeight: 1.35,
  textAlign: "right",
  width: "100%"
};
const DEAL_SELECTION_GRID_STYLE = {
  direction: "rtl",
  display: "grid",
  gap: 16,
  gridTemplateColumns: "1fr",
  marginBottom: 16,
  width: "100%"
};
const DEAL_FIELD_ROW_STYLE = {
  alignItems: "center",
  display: "flex",
  gap: 10,
  minWidth: 0
};
const DEAL_FIELD_LABEL_STYLE = {
  color: "#1e3d66",
  flexShrink: 0,
  fontSize: 15,
  fontWeight: 700,
  whiteSpace: "nowrap"
};
const ANALYZE_ACTION_ROW_STYLE = {
  alignItems: "stretch",
  direction: "rtl",
  display: "flex",
  flexDirection: "column",
  marginTop: 0
};
const CANDIDATE_DEALS_NOTICE_STYLE = {
  background: "#fff8e8",
  border: "1.5px dashed #ffb109",
  borderRadius: 12,
  boxSizing: "border-box",
  color: "#1e3d66",
  direction: "rtl",
  maxWidth: "100%",
  minWidth: 0,
  padding: "12px 16px",
  textAlign: "right",
  whiteSpace: "normal"
};
const CANDIDATE_DEALS_NOTICE_TEXT_STYLE = {
  display: "block",
  lineHeight: 1.45,
  minWidth: 0,
  overflowWrap: "break-word",
  whiteSpace: "normal"
};
const DIALOG_FOOTER_STYLE = {
  borderTop: "1px solid #d5e0ea",
  direction: "rtl",
  display: "flex",
  gap: 12,
  justifyContent: "center",
  margin: "18px -28px 0",
  padding: "16px 28px 20px"
};
const FOOTER_BUTTON_STYLE = {
  borderRadius: 20,
  boxShadow: "none",
  fontSize: 16,
  fontWeight: 700,
  minHeight: 40,
  minWidth: 120,
  padding: "6px 22px",
  textTransform: "none"
};
const CANCEL_BUTTON_STYLE = {
  ...FOOTER_BUTTON_STYLE,
  background: "#ffffff",
  border: "1.5px solid #1e3d66",
  color: "#1e3d66"
};
const ANALYZE_BUTTON_STYLE = {
  ...FOOTER_BUTTON_STYLE,
  background: "#1e3d66",
  color: "#fff",
  minWidth: 160
};
const DEAL_NUMBER_TAG_STYLE = {
  alignItems: "center",
  background: "#e8eef4",
  border: "1px solid #c5d3e0",
  borderRadius: 999,
  color: "#1e3d66",
  direction: "rtl",
  display: "inline-flex",
  fontSize: 12,
  fontWeight: 700,
  gap: 3,
  lineHeight: 1.2,
  padding: "3px 10px",
  whiteSpace: "nowrap"
};
const DEAL_LABEL_STYLE = {
  alignItems: "center",
  direction: "rtl",
  display: "flex",
  flexWrap: "nowrap",
  gap: 8,
  justifyContent: "flex-start",
  maxWidth: "100%",
  minWidth: 0,
  overflowWrap: "anywhere"
};
const DEAL_LABEL_TEXT_STYLE = {
  color: "#1e3d66",
  flex: "1 1 auto",
  fontWeight: 700,
  minWidth: 0,
  overflow: "hidden",
  textAlign: "right",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
};
const JSON_EXPORT_SECTION_STYLE = {
  borderTop: "1px solid #d5e0ea",
  direction: "rtl",
  marginBottom: 8,
  marginTop: 18,
  paddingTop: 16,
  textAlign: "right"
};
const JSON_EXPORT_CARD_STYLE = {
  alignItems: "center",
  background: "#f7fafc",
  border: "1.5px dashed #b8c9d8",
  borderRadius: 12,
  boxSizing: "border-box",
  direction: "rtl",
  display: "flex",
  gap: 12,
  justifyContent: "space-between",
  minWidth: 0,
  padding: "12px 14px",
  textAlign: "right",
  width: "100%"
};
const JSON_EXPORT_BUTTONS_STYLE = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  flexShrink: 0,
  flexWrap: "wrap",
  gap: 8,
  justifyContent: "flex-end"
};
const JSON_EXPORT_BUTTON_STYLE = {
  background: "linear-gradient(180deg, #ffb109 0%, #ff9800 100%)",
  borderRadius: 18,
  boxShadow: "0 2px 6px rgba(255, 152, 0, 0.25)",
  color: "#ffffff",
  fontWeight: 700,
  maxWidth: "100%",
  minWidth: 140,
  padding: "6px 14px",
  textTransform: "none",
  width: "auto"
};
const INSTRUCTION_CONTAINER_STYLE = { ...RTL_TEXT_STYLE, color: "#1e3d66", lineHeight: 1.65, width: "100%" };
const INSTRUCTION_STEPS_STYLE = { display: "flex", flexDirection: "column", gap: 10 };
const INSTRUCTION_STEP_ROW_STYLE = { alignItems: "flex-start", display: "flex", gap: 10 };
const INSTRUCTION_STEP_NUMBER_STYLE = {
  alignItems: "center",
  background: "#1e3d66",
  borderRadius: "50%",
  color: "#ffffff",
  display: "inline-flex",
  flexShrink: 0,
  fontSize: 14,
  fontWeight: 800,
  height: 26,
  justifyContent: "center",
  marginTop: 1,
  width: 26
};
const INSTRUCTION_STEP_TEXT_STYLE = { color: "#1e3d66", fontSize: 16, wordBreak: "break-word" };
const EMPHASIZED_ROUTE_STYLE = { textDecoration: "underline" };
const SECONDARY_OPTION_PANEL_STYLE = {
  background: "#fff",
  border: "1px solid #d5e0ea",
  borderRadius: "0 0 12px 12px",
  boxShadow: "0 2px 8px rgba(30, 61, 102, 0.08)",
  direction: "rtl",
  marginTop: -1,
  padding: 16,
  position: "relative",
  textAlign: "right"
};
const SECONDARY_TOGGLE_ROW_STYLE = {
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  gap: 10,
  justifyContent: "stretch"
};
const SECONDARY_TABS_STYLE = { height: 48, minHeight: 48, overflow: "hidden", position: "relative", zIndex: 2 };
const RESULTS_SECTION_TITLE_STYLE = {
  color: "#1e3d66",
  fontSize: 18,
  fontWeight: 800,
  margin: 0,
  textAlign: "right"
};
const RESULTS_SECTION_SUBTITLE_STYLE = {
  color: "#1e3d66",
  fontSize: 16,
  lineHeight: 1.5,
  marginTop: 6,
  textAlign: "right"
};
const RESULTS_DIVIDER_STYLE = {
  border: 0,
  borderTop: "1px solid #d5e0ea",
  margin: "20px 0"
};
const CREATE_DOCS_BUTTON_STYLE = {
  background: "linear-gradient(180deg, #ffb109 0%, #ff9800 100%)",
  borderRadius: 20,
  boxShadow: "0 3px 8px rgba(255, 152, 0, 0.28)",
  color: "#ffffff",
  fontSize: 16,
  fontWeight: 800,
  minHeight: 44,
  minWidth: "100%",
  padding: "8px 22px",
  textTransform: "none",
  width: "100%"
};
const SECONDARY_TOGGLE_BUTTON_STYLE = {
  background: "#1e3d66",
  borderRadius: 12,
  boxShadow: "none",
  color: "#ffffff",
  fontSize: 15,
  fontWeight: 700,
  minHeight: 44,
  padding: "8px 18px",
  textTransform: "none",
  width: "100%"
};
const RESULTS_BACK_BUTTON_STYLE = {
  background: "#ffffff",
  border: "1.5px solid #1e3d66",
  borderRadius: 20,
  boxShadow: "none",
  color: "#1e3d66",
  fontSize: 15,
  fontWeight: 700,
  minHeight: 40,
  minWidth: 160,
  padding: "6px 18px",
  textTransform: "none"
};
const RESULTS_FOOTER_STYLE = {
  borderTop: "1px solid #d5e0ea",
  direction: "rtl",
  display: "flex",
  justifyContent: "flex-start",
  margin: "20px -28px 0",
  padding: "16px 28px 8px"
};

const getEligibilityDetailsStyle = (maxHeight, isVisible) => ({
  maxHeight,
  opacity: isVisible ? 1 : 0,
  overflow: "hidden",
  transform: isVisible ? "translateY(0)" : "translateY(-6px)",
  transition: "max-height 220ms ease, opacity 180ms ease, transform 180ms ease"
});

const getJsonExportGridStyle = () => ({
  direction: "rtl",
  display: "flex",
  flexDirection: "column",
  gap: 10,
  width: "100%"
});

const getSecondaryToggleRowStyle = (isOptionsShown) => ({
  ...SECONDARY_TOGGLE_ROW_STYLE,
  marginBottom: isOptionsShown ? 22 : 0
});

const getSecondaryTabStyle = (isSelected) => ({
  background: isSelected ? "#fff" : "#eeeeee",
  border: "1px solid #d8d8d8",
  borderBottom: isSelected ? "1px solid #fff" : "1px solid #d8d8d8",
  borderRadius: "8px 8px 0 0",
  boxShadow: isSelected ? "0 1px 0 0 #fff" : "none",
  boxSizing: "border-box",
  color: isSelected ? "#12313d" : "#606060",
  cursor: "pointer",
  fontWeight: isSelected ? 700 : 600,
  height: 48,
  marginLeft: 2,
  minHeight: 48,
  minWidth: 130,
  padding: "7px 14px",
  position: "relative",
  textTransform: "none",
  zIndex: isSelected ? 2 : 1
});

const getSecondaryTaxLabelStyle = (isSelected) => ({ color: isSelected ? "#12313d" : "#707070", fontSize: 12 });
const TOTAL_TAX_BOX_STYLE = {
  background: "#f4f8fb",
  border: "2px dashed #ff9800",
  borderRadius: 12,
  boxSizing: "border-box",
  color: "#1e3d66",
  direction: "rtl",
  fontSize: 18,
  fontWeight: 800,
  margin: "20px 0 0",
  padding: "14px 18px",
  textAlign: "center",
  width: "100%"
};
const TOTAL_TAX_VALUE_STYLE = {
  fontWeight: 800,
  whiteSpace: "nowrap"
};

class Dialog49a extends Component {
  state = {
    hasMaxTwoApas: "",
    isAllowedSingleApaPtor: "",
    dealOne: null,
    dealTwo: null,
    currentPage: "input",
    expandedSecondaryOptionIndex: null,
    calculationRes: "",
    secondaryOpts: [],
    candidateDeals: [],
    isLoading49aCandidateDeals: false
  };

  candidateDealsRequestId = 0;
  secondaryOptionsPanelRef = React.createRef();

  componentDidMount() {
    if (this.props.open) this.load49aCandidateDeals();
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) this.load49aCandidateDeals();
  }

  load49aCandidateDeals = () => {
    const requestId = ++this.candidateDealsRequestId;
    this.setState({ isLoading49aCandidateDeals: true });

    dealsService
      .get49aCandidateDeals()
      .then((res) => {
        if (requestId !== this.candidateDealsRequestId) return;
        if (res.success) {
          this.setState({ candidateDeals: res.deals || [], isLoading49aCandidateDeals: false });
          return;
        }
        this.setState({ candidateDeals: [], isLoading49aCandidateDeals: false });
        Swal.fire("לא ניתן לטעון את רשימת העסקאות", "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר", "warning");
      })
      .catch(() => {
        if (requestId !== this.candidateDealsRequestId) return;
        this.setState({ candidateDeals: [], isLoading49aCandidateDeals: false });
        Swal.fire("לא ניתן לטעון את רשימת העסקאות", "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר", "warning");
      });
  };

  renderRtlAutocompleteInput = (params, selectedDeal, ariaLabel) => (
    <TextField
      {...params}
      variant="outlined"
      size="small"
      inputProps={{
        ...params.inputProps,
        "aria-label": ariaLabel,
        dir: "rtl",
        style: {
          ...(params.inputProps?.style || {}),
          overflow: "hidden",
          textAlign: "right"
        }
      }}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            {selectedDeal?.prettyId ? (
              <InputAdornment position="end" style={{ marginLeft: 4, marginRight: 0 }}>
                {this.renderDealNumberTag(selectedDeal.prettyId)}
              </InputAdornment>
            ) : null}
            {params.InputProps.endAdornment}
          </>
        ),
        style: {
          ...((params.InputProps || {}).style || {}),
          background: "#ffffff",
          borderRadius: 20,
          direction: "rtl",
          height: 38
        }
      }}
    />
  );

  getCandidateDealOptionLabel = (option) => {
    if (!option) return "";
    if (typeof option === "string") return option;

    const dealDescription = option.dealDescription || "";
    const prettyId = option.prettyId || "";

    return dealDescription || `${prettyId}`;
  };

  getCandidateDealFullLabel = (option) => {
    if (!option) return "";
    if (typeof option === "string") return option;

    const dealDescription = option.dealDescription || "";
    const prettyId = option.prettyId || "";

    if (dealDescription && prettyId) return `${dealDescription} - ${prettyId}`;
    return dealDescription || `${prettyId}`;
  };

  getCandidateDealProseLabel = (option, otherOption) => {
    if (!option) return "";
    if (typeof option === "string") return option;

    const dealDescription = (option.dealDescription || "").trim();
    const prettyId = option.prettyId || "";
    const otherDealDescription = (otherOption?.dealDescription || "").trim();

    if (!dealDescription) return prettyId ? `עסקה ${prettyId}` : "";
    if (prettyId && dealDescription && dealDescription === otherDealDescription) return `${dealDescription} (${prettyId})`;

    return dealDescription;
  };

  getCandidateDealSearchLabel = this.getCandidateDealFullLabel;

  filterCandidateDealOptions = (options, { inputValue }) => {
    const normalizedInput = inputValue.trim().toLowerCase();
    if (!normalizedInput) return options;

    return options.filter((option) => this.getCandidateDealSearchLabel(option).toLowerCase().includes(normalizedInput));
  };

  isSameCandidateDeal = (option, selectedDeal) => Boolean(option && selectedDeal && option._id === selectedDeal._id);

  handleCandidateDealChange = (stateKey, otherStateKey, selectedDeal) => {
    if (this.isSameCandidateDeal(selectedDeal, this.state[otherStateKey])) return;
    this.handleOnChange(stateKey, selectedDeal);
  };

  renderCandidateDealOption = (option) => (
    <div style={CANDIDATE_OPTION_STYLE}>
      {option.dealDescription ? (
        this.renderDealLabelWithNumber(this.getCandidateDealFullLabel(option))
      ) : (
        <span style={{ alignItems: "center", display: "inline-flex", gap: 6 }}>
          <span>עסקה</span>
          {this.renderDealNumberTag(option.prettyId)}
        </span>
      )}
    </div>
  );

  renderRadioOptions = (stateKey, options) => (
    <div role="radiogroup" style={RADIO_GROUP_STYLE}>
      {options.map((option) => {
        const isSelected = this.state[stateKey] === option.value;

        return (
          <button
            aria-checked={isSelected}
            key={option.value}
            onClick={() => this.handleOnChange(stateKey, option.value)}
            role="radio"
            style={{ ...RADIO_OPTION_STYLE, ...(isSelected ? SELECTED_RADIO_OPTION_STYLE : {}) }}
            type="button"
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );

  renderEligibilitySeparator = () => <hr style={ELIGIBILITY_SEPARATOR_STYLE} />;

  renderEligibilityQuestions = () => (
    <div style={ELIGIBILITY_GRID_STYLE}>
      <FormControl component="div" style={ELIGIBILITY_QUESTION_STYLE}>
        <FormLabel component="div" style={FORM_LABEL_STYLE}>
          כמה דירות יש ללקוח?
        </FormLabel>
        {this.renderRadioOptions("hasMaxTwoApas", [
          { value: "exactlyTwoApas", label: "שתי דירות" },
          { value: "moreThanTwoApas", label: "יותר משתי דירות" }
        ])}
      </FormControl>

      {this.renderEligibilitySeparator()}

      <FormControl component="div" style={ELIGIBILITY_QUESTION_STYLE}>
        <FormLabel component="div" style={FORM_LABEL_STYLE}>
          אם הייתה ללקוח דירה אחת בלבד,
          <br />
          האם היה זכאי לפטור דירה יחידה?
        </FormLabel>
        {this.renderRadioOptions("isAllowedSingleApaPtor", [
          { value: "allowedSingleApaPtor", label: "כן" },
          { value: "notAllowedSingleApaPtor", label: "לא" }
        ])}
      </FormControl>
    </div>
  );

  render() {
    const isAllowed49a = this.isAllowed49a();

    const calculationRes = this.state.calculationRes;

    const bestTaxOptTable = this.createTaxTypesTable(calculationRes?.bestSampleForDocsCreation, calculationRes?.instructionsForClientBody);
    const candidateDeals = this.state.candidateDeals;
    const isResultsPage = this.state.currentPage === "results" && calculationRes;
    const eligibilityDetailsMaxHeight = isAllowed49a === "allowed" ? 440 : isAllowed49a === "notAllowed" ? 120 : 0;
    const isEligibilityDetailsVisible = Boolean(isAllowed49a);

    return (
      <CustomDialog
        contentStyle={{ padding: 0 }}
        hideCloseButton
        isContentDivided={false}
        label={isResultsPage ? "49(ה)- מכירת שתי דירות בפטור - תוצאות" : "49(ה)- מכירת שתי דירות בפטור"}
        maxWidth="sm"
        open={this.props.open}
        onClose={this.cleanAndClosePopup}
        paperStyle={DIALOG_PAPER_STYLE}
        titleAlign="center"
        titleStyle={DIALOG_TITLE_STYLE}
        titleTypographyStyle={DIALOG_TITLE_TYPOGRAPHY_STYLE}
      >
        <div className={`dialog49a${isResultsPage ? " dialog49a-results" : ""}`} style={DIALOG_CONTENT_STYLE}>
          {!isResultsPage ? (
            <>
              {this.renderEligibilityQuestions()}

              <div style={getEligibilityDetailsStyle(eligibilityDetailsMaxHeight, isEligibilityDetailsVisible)}>
                {isAllowed49a === "allowed" ? (
                  <div>
                    {this.renderEligibilitySeparator()}
                    <h3 style={{ color: "#1e3d66", fontSize: 16, fontWeight: 800, margin: "18px 0 14px", textAlign: "right" }}>
                      יש לבחור שתי עסקאות להמלצה
                    </h3>

                    <div style={DEAL_SELECTION_GRID_STYLE}>
                      <div style={DEAL_FIELD_ROW_STYLE}>
                        <span style={DEAL_FIELD_LABEL_STYLE}>דירה א׳</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <Autocomplete
                            fullWidth
                            value={this.state.dealOne}
                            blurOnSelect
                            options={candidateDeals}
                            filterOptions={this.filterCandidateDealOptions}
                            getOptionLabel={this.getCandidateDealOptionLabel}
                            getOptionDisabled={(option) => this.isSameCandidateDeal(option, this.state.dealTwo)}
                            getOptionSelected={(option, value) => option._id === value._id}
                            loading={this.state.isLoading49aCandidateDeals}
                            loadingText="טוען עסקאות..."
                            noOptionsText="לא נמצאו עסקאות מחושבות"
                            openOnFocus
                            renderOption={this.renderCandidateDealOption}
                            renderInput={(params) => this.renderRtlAutocompleteInput(params, this.state.dealOne, "דירה א׳ שנבחרה")}
                            onChange={(e, val) => this.handleCandidateDealChange("dealOne", "dealTwo", val)}
                          />
                        </div>
                      </div>
                      <div style={DEAL_FIELD_ROW_STYLE}>
                        <span style={DEAL_FIELD_LABEL_STYLE}>דירה ב׳</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <Autocomplete
                            fullWidth
                            value={this.state.dealTwo}
                            blurOnSelect
                            options={candidateDeals}
                            filterOptions={this.filterCandidateDealOptions}
                            getOptionLabel={this.getCandidateDealOptionLabel}
                            getOptionDisabled={(option) => this.isSameCandidateDeal(option, this.state.dealOne)}
                            getOptionSelected={(option, value) => option._id === value._id}
                            loading={this.state.isLoading49aCandidateDeals}
                            loadingText="טוען עסקאות..."
                            noOptionsText="לא נמצאו עסקאות מחושבות"
                            openOnFocus
                            renderOption={this.renderCandidateDealOption}
                            renderInput={(params) => this.renderRtlAutocompleteInput(params, this.state.dealTwo, "דירה ב׳ שנבחרה")}
                            onChange={(e, val) => {
                              this.handleCandidateDealChange("dealTwo", "dealOne", val);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div style={ANALYZE_ACTION_ROW_STYLE}>
                      <div style={CANDIDATE_DEALS_NOTICE_STYLE}>
                        <span style={CANDIDATE_DEALS_NOTICE_TEXT_STYLE}>
                          לא מוצאים את העסקה? המערכת מציגה רק עסקאות שהחישוב שלהן הושלם.
                        </span>
                      </div>
                    </div>
                  </div>
                ) : isAllowed49a === "notAllowed" ? (
                  <h2 className="yellow-color">הלקוח לא זכאי לפטור 49(ה)</h2>
                ) : null}
              </div>
              <div style={DIALOG_FOOTER_STYLE}>
                <Button onClick={this.cleanAndClosePopup} style={CANCEL_BUTTON_STYLE} variant="outlined">
                  ביטול
                </Button>
                <Button onClick={this.handleAnalyzeClick} style={ANALYZE_BUTTON_STYLE} variant="contained">
                  לחץ לניתוח
                </Button>
              </div>
            </>
          ) : null}

          {isResultsPage ? (
            <div style={{ paddingTop: 22 }}>
              <div style={{ direction: "rtl", textAlign: "right" }}>
                <div style={RESULTS_SECTION_TITLE_STYLE}>המלצת המערכת</div>
                <div style={RESULTS_SECTION_SUBTITLE_STYLE}>{calculationRes.instructionsForClientTitle}</div>
              </div>

              <div style={{ marginTop: 18 }}>{this.render49aInstruction(calculationRes.instructionsForClientBody)}</div>

              {this.renderTotalTaxLine(calculationRes.finalCheapestSummedTax)}

              <hr style={RESULTS_DIVIDER_STYLE} />

              <div>
                <div style={{ ...RESULTS_SECTION_TITLE_STYLE, marginBottom: 10 }}>פירוט המיסוי</div>
                <CustomBasicTable headers={["עסקה", "לינארי ישן", "מס מוטב"]} rows={bestTaxOptTable} />
                {this.renderPurchaseTaxDisclaimer()}
              </div>

              <hr style={RESULTS_DIVIDER_STYLE} />

              {this.is2990NotNeeded() ? (
                <b>אין צורך ביצירת קבצי 2990 - הדירות בפטור מלא ללא חבות מס</b>
              ) : (
                <>
                  <Button
                    style={CREATE_DOCS_BUTTON_STYLE}
                    variant="contained"
                    onClick={() => this.create49aDocs2990(this.state.calculationRes.bestSampleOptionKey)}
                  >
                    יצירת מסמכי 2990
                  </Button>
                  {this.render49aJsonButtons(
                    this.state.calculationRes.bestSampleForDocsCreation,
                    this.state.calculationRes.bestSampleOptionKey
                  )}
                </>
              )}

              {this.renderSecondaryOptions()}

              <div style={RESULTS_FOOTER_STYLE}>
                <Button
                  variant="outlined"
                  endIcon={<ArrowForwardIcon style={{ marginRight: "8px" }} />}
                  style={RESULTS_BACK_BUTTON_STYLE}
                  onClick={() => this.setState({ currentPage: "input" })}
                >
                  חזרה לבחירה
                </Button>
              </div>
            </div>
          ) : null}
        </div>
      </CustomDialog>
    );
  }

  createTaxTypesTable = (sampleDealCase, instruction) => {
    const tableExtraDataRows = [];
    if (sampleDealCase) {
      tableExtraDataRows.push({
        prettyName: sampleDealCase.firstPrettyName,
        row: [
          this.renderDealLabelWithNumber(sampleDealCase.firstPrettyName),
          sampleDealCase.resMainCalc1.data.mainCalc.calculatedData.dataPerPart[0].actualFinalLinear26,
          // (sampleDealCase.resMainCalc1.data.mainCalc.calculatedData.dataPerPart[0].afterKizuzimInflation10 || 0),
          sampleDealCase.resMainCalc1.data.mainCalc.calculatedData.dataPerPart[0].actualFinalMutav26
        ]
      });
      if (sampleDealCase.secondPrettyName) {
        tableExtraDataRows.push({
          prettyName: sampleDealCase.secondPrettyName,
          row: [
            this.renderDealLabelWithNumber(sampleDealCase.secondPrettyName),
            sampleDealCase.resMainCalc2.data.mainCalc.calculatedData.dataPerPart[0].actualFinalLinear26,
            // (sampleDealCase.resMainCalc2.data.mainCalc.calculatedData.dataPerPart[0].afterKizuzimInflation10 || 0),
            sampleDealCase.resMainCalc2.data.mainCalc.calculatedData.dataPerPart[0].actualFinalMutav26
          ]
        });
      }
    }
    return this.orderTaxTableRowsByInstruction(tableExtraDataRows, instruction).map((tableRow) => tableRow.row);
  };

  orderTaxTableRowsByInstruction = (tableRows, instruction) => {
    const steps = instruction?.steps || [];
    if (tableRows.length < 2 || !steps.length) return tableRows;

    const rowsWithOrder = tableRows.map((tableRow) => ({
      ...tableRow,
      instructionIndex: steps.findIndex((step) => this.isInstructionDealNameMatch(step.dealName, tableRow.prettyName))
    }));

    if (rowsWithOrder.some((tableRow) => tableRow.instructionIndex < 0)) return tableRows;

    const matchedInstructionIndexes = rowsWithOrder.map((tableRow) => tableRow.instructionIndex);
    if (new Set(matchedInstructionIndexes).size !== rowsWithOrder.length) return tableRows;

    return rowsWithOrder.sort((left, right) => left.instructionIndex - right.instructionIndex);
  };

  isInstructionDealNameMatch = (instructionDealName = "", prettyName = "") => {
    const { name, prettyId } = this.getDealNameParts(prettyName);
    const normalizedInstructionDealName = this.normalizeDealNameForOrder(instructionDealName);
    const possibleNames = [prettyName, name, prettyId ? `${name} (${prettyId})` : "", prettyId ? `עסקה ${prettyId}` : ""]
      .filter(Boolean)
      .map(this.normalizeDealNameForOrder);

    return possibleNames.includes(normalizedInstructionDealName);
  };

  normalizeDealNameForOrder = (dealName = "") => {
    return `${dealName}`.replace(/\s+/g, " ").trim();
  };

  renderPurchaseTaxDisclaimer = () => (
    <div style={{ color: "#7a8fa3", direction: "rtl", fontSize: 13, marginTop: 10, textAlign: "right" }}>
      * החישוב אינו כולל התייחסות למס רכישה.
    </div>
  );

  create49aDocs2990 = async (optionKey) => {
    const confirmed = await confirmTaxAuthorityDocumentGenerationOncePerDeal({
      dealIds: [this.state.dealOne._id, this.state.dealTwo._id],
      fullName: this.props.fullName,
      licenseNumber: this.props.licenseNumber,
      disableTaxAuthorityDocumentConfirmation: this.props.disableTaxAuthorityDocumentConfirmation
    });
    if (!confirmed) {
      return;
    }

    filesService
      .create49aDocs2990(this.state.dealOne._id, this.state.dealTwo._id, optionKey)
      .then(() => {
        Swal.fire("מסמכים ירדו בהצלחה", "", "success");
      })
      .catch(() => {
        Swal.fire("היתה בעיה בהורדת הקובץ", "", "warning");
      });
  };

  getDealNameParts = (dealName = "") => {
    const parts = dealName.split(" - ");
    const firstPart = parts[0] || "";
    const lastPart = parts[parts.length - 1] || "";

    if (parts.length > 1 && /^\d+$/.test(firstPart)) {
      return { name: parts.slice(1).join(" - "), prettyId: firstPart };
    }

    if (parts.length > 1 && /^\d+$/.test(lastPart)) {
      return { name: parts.slice(0, -1).join(" - "), prettyId: lastPart };
    }

    return { name: dealName, prettyId: "" };
  };

  renderDealNumberTag = (prettyId) => {
    if (!prettyId) return null;

    return (
      <span style={DEAL_NUMBER_TAG_STYLE}>
        <span>מס׳</span>
        <span style={{ direction: "ltr" }}>{prettyId}</span>
      </span>
    );
  };

  renderDealLabelWithNumber = (dealName = "") => {
    const { name, prettyId } = this.getDealNameParts(dealName);

    return (
      <span title={dealName} style={DEAL_LABEL_STYLE}>
        <span style={DEAL_LABEL_TEXT_STYLE}>{name || dealName}</span>
        {this.renderDealNumberTag(prettyId)}
      </span>
    );
  };

  render49aJsonButtons = (sampleForDocsCreation, optionKey) => {
    const exportGroups = get49aJsonExportGroups(sampleForDocsCreation, optionKey);
    if (!exportGroups.length) return null;

    return (
      <div style={JSON_EXPORT_SECTION_STYLE}>
        <div style={{ ...RESULTS_SECTION_TITLE_STYLE, fontSize: 16, marginBottom: 12 }}>
          קבצים מוכנים להגשה לרשות המסים
        </div>
        <div style={getJsonExportGridStyle()}>
          {exportGroups.map((group) => {
            const { name, prettyId } = this.getDealNameParts(group.dealName);

            return (
              <div key={group.targetDealKey} style={JSON_EXPORT_CARD_STYLE}>
                <div style={{ flex: "1 1 auto", lineHeight: 1.35, minWidth: 0 }}>
                  {this.renderDealLabelWithNumber(name && prettyId ? `${name} - ${prettyId}` : group.dealName)}
                </div>
                <div style={JSON_EXPORT_BUTTONS_STYLE}>
                  {group.files.map((file) => (
                    <Button
                      key={file.dealTaxType + file.dealIndex}
                      onClick={() => this.generate49a2990Json(group, file)}
                      endIcon={<GetApp style={{ color: "#ffffff", marginRight: "8px" }} />}
                      variant="contained"
                      size="small"
                      style={JSON_EXPORT_BUTTON_STYLE}
                    >
                      {file.label}
                    </Button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  generate49a2990Json = (group, file) => {
    filesService
      .generate49a2990Json(
        this.state.dealOne._id,
        this.state.dealTwo._id,
        group.optionKey,
        group.targetDealKey,
        file.dealTaxType,
        file.dealIndex,
        group.dealName
      )
      .catch((err) => {
        Swal.fire("היתה בעיה ביצירת הקובץ", err && err.message ? err.message : "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר", "warning");
      });
  };

  handleOnChange = (key, val) => {
    this.setState({ [key]: val, calculationRes: null, currentPage: "input", expandedSecondaryOptionIndex: null });
  };

  handleAnalyzeClick = () => {
    const eligibilityStatus = this.isAllowed49a();

    if (!eligibilityStatus) {
      return Swal.fire("חובה לענות על שתי השאלות", "", "info");
    }

    if (eligibilityStatus === "notAllowed") {
      return Swal.fire("הלקוח לא זכאי לפטור 49(ה)", "", "info");
    }

    return this.execute49a();
  };

  isAllowed49a = () => {
    const { hasMaxTwoApas, isAllowedSingleApaPtor } = this.state;
    // still both of the radios are not inserted.. we dont know if has ptor 49a
    if (!hasMaxTwoApas && !isAllowedSingleApaPtor) return null;

    if (hasMaxTwoApas) {
      if (hasMaxTwoApas === "moreThanTwoApas") return "notAllowed";
      if (!isAllowedSingleApaPtor) return null;
      if (isAllowedSingleApaPtor === "notAllowedSingleApaPtor") return "notAllowed";
      return "allowed";
    } else {
      if (isAllowedSingleApaPtor === "notAllowedSingleApaPtor") return "notAllowed";
      return null;
    }
  };

  render49aInstruction = (instruction) => {
    if (!instruction) return null;
    if (typeof instruction === "string") return instruction;

    const steps = instruction.steps || [];

    return (
      <div style={INSTRUCTION_CONTAINER_STYLE}>
        {instruction.summary ? <div style={{ fontSize: 17 }}>{instruction.summary}</div> : null}

        {steps.length ? (
          <div className={instruction.summary ? "mt-20" : ""}>
            <div style={{ ...RESULTS_SECTION_TITLE_STYLE, marginBottom: 10 }}>
              {instruction.isAlternative ? "סדר מכירה באפשרות זו" : "סדר המכירה המומלץ"}
            </div>
            <div style={INSTRUCTION_STEPS_STYLE}>
              {steps.map((step, index) => (
                <div key={typeof step === "string" ? step : `${step.lead}-${step.dealName}-${index}`} style={INSTRUCTION_STEP_ROW_STYLE}>
                  <span style={INSTRUCTION_STEP_NUMBER_STYLE}>{index + 1}</span>
                  <span style={INSTRUCTION_STEP_TEXT_STYLE}>{this.renderInstructionStepText(step, instruction.isAlternative)}</span>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  renderInstructionStepText = (step, isAlternative) => {
    if (typeof step === "string") return step;

    if (isAlternative) {
      return (
        <>
          <span>{step.lead === "ראשית" ? "אם תמכור את " : "ולאחר מכן תמכור את "}</span>
          <strong>{step.dealName}</strong> <strong style={EMPHASIZED_ROUTE_STYLE}>{step.route}</strong>
          {"."}
        </>
      );
    }

    return (
      <>
        <span>{step.lead}</span>
        {", מומלץ למכור את "}
        <strong>{step.dealName}</strong> <strong style={EMPHASIZED_ROUTE_STYLE}>{step.route}</strong>
        {"."}
      </>
    );
  };

  handleSecondaryOptionsToggle = () => {
    const isOptionsShown = Number.isInteger(this.state.expandedSecondaryOptionIndex);

    if (isOptionsShown) {
      this.setState({ expandedSecondaryOptionIndex: null });
      return;
    }

    this.setState({ expandedSecondaryOptionIndex: 0 }, this.scrollSecondaryOptionsPanelIntoView);
  };

  scrollSecondaryOptionsPanelIntoView = () => {
    if (!this.secondaryOptionsPanelRef.current) return;

    this.secondaryOptionsPanelRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };

  renderSecondaryOptionContent = (secondaryOpt) => {
    if (!secondaryOpt) return null;

    const secondaryTax = numberWithCommas(parseInt(this.getFinalDealTax(secondaryOpt.taxObj)));

    return (
      <div style={SECONDARY_OPTION_PANEL_STYLE}>
        {this.render49aInstruction(secondaryOpt.explanation)}
        {this.renderTotalTaxLine(secondaryTax)}
        <div style={{ marginTop: 16 }}>
          <div style={{ ...RESULTS_SECTION_TITLE_STYLE, marginBottom: 10 }}>פירוט המיסוי</div>
          <CustomBasicTable
            headers={["עסקה", "לינארי ישן", "מס מוטב"]}
            rows={this.createTaxTypesTable(secondaryOpt.taxObj, secondaryOpt.explanation)}
          />
          {this.renderPurchaseTaxDisclaimer()}
        </div>

        <div style={{ marginTop: 16 }}>
          <Button style={CREATE_DOCS_BUTTON_STYLE} variant="contained" onClick={() => this.create49aDocs2990(secondaryOpt.optionKey)}>
            יצירת מסמכי 2990
          </Button>
          {this.render49aJsonButtons(secondaryOpt.taxObj, secondaryOpt.optionKey)}
        </div>
      </div>
    );
  };

  renderSecondaryOptions = () => {
    if (!this.state.secondaryOpts.length) return null;

    const isOptionsShown = Number.isInteger(this.state.expandedSecondaryOptionIndex);
    const selectedOptionIndex = isOptionsShown ? Math.min(this.state.expandedSecondaryOptionIndex, this.state.secondaryOpts.length - 1) : 0;
    const selectedSecondaryOpt = this.state.secondaryOpts[selectedOptionIndex];

    return (
      <div style={{ direction: "rtl", marginTop: 18, textAlign: "right" }}>
        <div style={getSecondaryToggleRowStyle(isOptionsShown)}>
          <Button
            variant="contained"
            endIcon={isOptionsShown ? <ExpandLessIcon style={{ marginRight: "8px" }} /> : <ExpandMoreIcon style={{ marginRight: "8px" }} />}
            style={SECONDARY_TOGGLE_BUTTON_STYLE}
            onClick={this.handleSecondaryOptionsToggle}
          >
            {isOptionsShown ? "הסתר אפשרויות פחות מומלצות" : "הצג אפשרויות פחות מומלצות"}
          </Button>
        </div>

        {isOptionsShown ? (
          <div ref={this.secondaryOptionsPanelRef}>
            <Tabs
              value={selectedOptionIndex}
              onChange={(event, value) => this.setState({ expandedSecondaryOptionIndex: value })}
              indicatorColor="secondary"
              textColor="secondary"
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{ style: { display: "none" } }}
              style={SECONDARY_TABS_STYLE}
            >
              {this.state.secondaryOpts.map((secondaryOpt, index) => {
                const secondaryTax = numberWithCommas(parseInt(this.getFinalDealTax(secondaryOpt.taxObj)));
                const isSelected = selectedOptionIndex === index;

                return (
                  <Tab
                    key={`secondary-option-${index}`}
                    style={getSecondaryTabStyle(isSelected)}
                    label={
                      <span style={{ display: "inline-flex", flexDirection: "column", lineHeight: 1.35 }}>
                        <span>אפשרות {index + 1}</span>
                        <span style={getSecondaryTaxLabelStyle(isSelected)}>מס: {secondaryTax} ₪</span>
                      </span>
                    }
                  />
                );
              })}
            </Tabs>
            <div>{this.renderSecondaryOptionContent(selectedSecondaryOpt, selectedOptionIndex)}</div>
          </div>
        ) : null}
      </div>
    );
  };

  renderTotalTaxLine = (taxAmount) => (
    <div style={TOTAL_TAX_BOX_STYLE}>
      <span>סה״כ מס שבח לתשלום: </span>
      <span style={TOTAL_TAX_VALUE_STYLE}>{taxAmount} ₪</span>
    </div>
  );

  createSecondaryOption = (explanation, taxObj, optionKey) => ({
    explanation: typeof explanation === "object" && explanation ? { ...explanation, isAlternative: true } : explanation,
    optionKey,
    taxObj
  });

  execute49a = () => {
    if (!this.state.dealOne || !this.state.dealTwo) {
      return Swal.fire("חובה לבחור שתי עסקאות", "", "info");
    }

    if (this.state.dealOne._id === this.state.dealTwo._id) {
      return Swal.fire("לא ניתן לבחור את אותה העסקה פעמיים", "", "info");
    }
    dealsService.execute49a(this.state.dealOne, this.state.dealTwo).then((res) => {
      if (res.success) {
        const secondaryOpts = [];

        const selectedDealProseName = this.getCandidateDealProseLabel(this.state.dealOne, this.state.dealTwo);
        const selectedDealProseName2 = this.getCandidateDealProseLabel(this.state.dealTwo, this.state.dealOne);

        const calculationRes = res.calculationRes;
        if (calculationRes.method === "1") {
          calculationRes.finalCheapestSummedTaxValue = this.getFinalDealTax(calculationRes.calcTwoRegDealsWithPtor);
          calculationRes.finalCheapestSummedTax = numberWithCommas(parseInt(calculationRes.finalCheapestSummedTaxValue));
          calculationRes.bestSampleForDocsCreation = calculationRes.calcTwoRegDealsWithPtor;
          calculationRes.bestSampleOptionKey = "calcTwoRegDealsWithPtor";
          delete calculationRes.calcTwoRegDealsWithPtor;
          calculationRes.instructionsForClientTitle = INSTRUCTION_TITLES.noSaleOrder;
          calculationRes.instructionsForClientBody = create49aFullExemptionInstruction(selectedDealProseName, selectedDealProseName2);
        } else {
          // Creating options / method 3
          let bestTaxOptionVal = this.getFinalDealTax(calculationRes.calcRegSample1);
          let bestTaxOptObjFromMethod3 = calculationRes.calcRegSample1;
          let bestTaxOptKeyFromMethod3 = "calcRegSample1";
          let bestTaxOptTextFromMethod3 = createRegularSaleInstruction(selectedDealProseName2, selectedDealProseName);

          let secondOpt = calculationRes.calcRegSample2;
          let secondOptKey = "calcRegSample2";
          let secondOptText = createRegularSaleInstruction(selectedDealProseName, selectedDealProseName2);

          let selectedActualDealData = calculationRes.calcRegSample1;
          let selectedActualDealDataKey = "calcRegSample1";
          let instructionsForClientTitle = INSTRUCTION_TITLES.no49aNeeded;
          let instructionsForClientBody = createRegularSaleInstruction(selectedDealProseName2, selectedDealProseName);

          const secondSample = this.getFinalDealTax(calculationRes.calcRegSample2);

          // If from the REGULAR tax options its better to sell in a different order.. then switch
          if (bestTaxOptionVal > secondSample) {
            bestTaxOptionVal = secondSample;
            bestTaxOptTextFromMethod3 = createRegularSaleInstruction(selectedDealProseName, selectedDealProseName2);
            bestTaxOptObjFromMethod3 = calculationRes.calcRegSample2;
            bestTaxOptKeyFromMethod3 = "calcRegSample2";

            secondOpt = calculationRes.calcRegSample1;
            secondOptKey = "calcRegSample1";
            secondOptText = createRegularSaleInstruction(selectedDealProseName2, selectedDealProseName);

            selectedActualDealData = calculationRes.calcRegSample2;
            selectedActualDealDataKey = "calcRegSample2";
            instructionsForClientBody = createRegularSaleInstruction(selectedDealProseName, selectedDealProseName2);
          }

          // Pushing from the method 3 (one mutav one reg tax) the less good option to the other options list.
          secondaryOpts.push(this.createSecondaryOption(secondOptText, secondOpt, secondOptKey));

          if (calculationRes.method === "2") {
            const thirdSample = this.getFinalDealTax(calculationRes.calcOneApaPtorSample1);

            let isBestTaxFromMethod3 = false;
            if (bestTaxOptionVal > thirdSample) {
              // If we found that partial usage of 49a is still better than BOTH alternatives of JUST regular tax(no 49a at all)
              secondaryOpts.push(this.createSecondaryOption(bestTaxOptTextFromMethod3, bestTaxOptObjFromMethod3, bestTaxOptKeyFromMethod3));

              bestTaxOptionVal = thirdSample;
              selectedActualDealData = calculationRes.calcOneApaPtorSample1;
              selectedActualDealDataKey = "calcOneApaPtorSample1";
              instructionsForClientTitle = INSTRUCTION_TITLES.used49a;
              instructionsForClientBody = create49aPartialExemptionInstruction(selectedDealProseName, selectedDealProseName2);
            } else {
              const text49A = create49aPartialExemptionInstruction(selectedDealProseName, selectedDealProseName2);
              isBestTaxFromMethod3 = true;
              secondaryOpts.push(this.createSecondaryOption(text49A, calculationRes.calcOneApaPtorSample1, "calcOneApaPtorSample1"));
            }

            const forthSample = this.getFinalDealTax(calculationRes.calcOneApaPtorSample2);

            if (bestTaxOptionVal > forthSample) {
              if (isBestTaxFromMethod3) {
                secondaryOpts.push(
                  this.createSecondaryOption(bestTaxOptTextFromMethod3, bestTaxOptObjFromMethod3, bestTaxOptKeyFromMethod3)
                );
              } else {
                const text49A = create49aPartialExemptionInstruction(selectedDealProseName, selectedDealProseName2);
                secondaryOpts.push(this.createSecondaryOption(text49A, calculationRes.calcOneApaPtorSample1, "calcOneApaPtorSample1"));
              }

              bestTaxOptionVal = forthSample;
              selectedActualDealData = calculationRes.calcOneApaPtorSample2;
              selectedActualDealDataKey = "calcOneApaPtorSample2";
              instructionsForClientTitle = INSTRUCTION_TITLES.used49a;
              instructionsForClientBody = create49aPartialExemptionInstruction(selectedDealProseName2, selectedDealProseName);
            } else {
              const text49A = create49aPartialExemptionInstruction(selectedDealProseName2, selectedDealProseName);
              secondaryOpts.push(this.createSecondaryOption(text49A, calculationRes.calcOneApaPtorSample2, "calcOneApaPtorSample2"));
            }
          }

          calculationRes.finalCheapestSummedTaxValue = bestTaxOptionVal;
          calculationRes.finalCheapestSummedTax = numberWithCommas(parseInt(bestTaxOptionVal));
          calculationRes.bestSampleForDocsCreation = selectedActualDealData;
          calculationRes.bestSampleOptionKey = selectedActualDealDataKey;
          calculationRes.instructionsForClientTitle = instructionsForClientTitle;
          calculationRes.instructionsForClientBody = instructionsForClientBody;
        }

        this.setState({
          calculationRes,
          secondaryOpts,
          currentPage: "results",
          expandedSecondaryOptionIndex: null
        });
      } else if (res.msgTitle) {
        Swal.fire(res.msgTitle, res.msgBody, "info");
      }
    });
  };

  getFinalDealTax = (deal) => {
    return (
      (deal.resMainCalc1?.data.mainCalc.calculatedData.dataPerPart[0].actualFinalLinear26 || 0) +
      (deal.resMainCalc1?.data.mainCalc.calculatedData.dataPerPart[0].actualFinalMutav26 || 0) +
      // (deal.resMainCalc1?.data.mainCalc.calculatedData.dataPerPart[0].afterKizuzimInflation10 || 0) +
      (deal.resMainCalc2?.data.mainCalc.calculatedData.dataPerPart[0].actualFinalLinear26 || 0) +
      (deal.resMainCalc2?.data.mainCalc.calculatedData.dataPerPart[0].actualFinalMutav26 || 0)
      // (deal.resMainCalc2?.data.mainCalc.calculatedData.dataPerPart[0].afterKizuzimInflation10 || 0)
    );
  };

  cleanAndClosePopup = () => {
    this.setState({
      hasMaxTwoApas: "",
      isAllowedSingleApaPtor: "",
      dealOne: null,
      dealTwo: null,
      calculationRes: null,
      currentPage: "input",
      expandedSecondaryOptionIndex: null,
      secondaryOpts: []
    });
    this.props.onClose();
  };

  is2990NotNeeded = () => {
    const { calculationRes } = this.state;
    const firstDealHasPtor =
      calculationRes?.bestSampleForDocsCreation?.resMainCalc1?.data?.preCalc?.preCalcPartsData[0].isSinglePropertyPtorAllowed;
    const secondDealHasPtor =
      calculationRes?.bestSampleForDocsCreation?.resMainCalc2?.data?.preCalc?.preCalcPartsData[0].isSinglePropertyPtorAllowed;

    return calculationRes.finalCheapestSummedTaxValue === 0 && calculationRes.method === "1" && firstDealHasPtor && secondDealHasPtor;
  };
}

const mapStateToProps = (state) => ({
  fullName: state.loggedinReducer.fullName,
  licenseNumber: state.loggedinReducer.licenseNumber,
  disableTaxAuthorityDocumentConfirmation: state.loggedinReducer.disableTaxAuthorityDocumentConfirmation
});

export default connect(mapStateToProps)(Dialog49a);
